import {boundMethod} from "autobind-decorator";
import React from "react";
import {injectIntl, IntlShape} from "react-intl";
import {Route, RouteComponentProps, Switch} from "react-router-dom";
import {Titled} from "react-titled";

import license from "@/services/license";
import {ESopLicenses} from "../license/models";
import {ETemplateTab} from "./models";

import MissingLicense from "@toolbox/render-page/MissingLicense";
import {intl2Str} from "@translate/T";
import DeleteTemplate from "./DeleteTemplate";
import EditTemplate from "./EditTemplate";
import TemplateList from "./TemplateList";

interface ITemplateProps {
    intl: IntlShape;
    baseUrl: string;
}

interface ITemplateState {
    templateTab: ETemplateTab;
}

class Template extends React.PureComponent<ITemplateProps, ITemplateState> {
    public readonly state: ITemplateState = {
        templateTab: ETemplateTab.Analysis,
    };

    @boundMethod
    public getTitle(parent: string) {
        return intl2Str(this.props.intl, "Templates") + " | " + parent;
    }

    @boundMethod
    public async onChangeTab(templateTab: ETemplateTab) {
        this.setState({templateTab});
    }

    public render() {
        const {baseUrl} = this.props;
        if (!license.status.sops.includes(ESopLicenses.Template)) {
            return (
                <MissingLicense missingSopLicenses={[ESopLicenses.Template]} />
            );
        }

        return (
            <Titled title={this.getTitle}>
                <Switch>
                    <Route
                        path={`${baseUrl}/analysis/edit/:id`}
                        render={this.renderEdit}
                    />
                    <Route
                        path={`${baseUrl}/sop/edit/:id`}
                        render={this.renderEdit}
                    />
                    <Route
                        path={`${baseUrl}/analysis/delete/:id`}
                        render={this.renderDelete}
                    />
                    <Route
                        path={`${baseUrl}/sop/delete/:id`}
                        render={this.renderDelete}
                    />

                    <Route render={this.renderList} />
                </Switch>
            </Titled>
        );
    }

    @boundMethod
    private renderEdit(props: RouteComponentProps<{id?: string}>) {
        const templateTab = this.getTemplateTabState(props.location.pathname);
        const id = props.match.params.id ?? "";

        return (
            <EditTemplate
                id={id}
                baseUrl={this.getBaseUrl()}
                templateTab={templateTab}
            />
        );
    }

    @boundMethod
    private renderDelete(props: RouteComponentProps<{id?: string}>) {
        const templateTab = this.getTemplateTabState(props.location.pathname);
        const id = props.match.params.id ?? "";

        return (
            <DeleteTemplate
                id={id}
                baseUrl={this.getBaseUrl()}
                templateTab={templateTab}
            />
        );
    }

    @boundMethod
    private renderList(props: RouteComponentProps) {
        const templateTab = this.getTemplateTabState(props.location.pathname);

        return (
            <TemplateList
                baseUrl={this.getBaseUrl(templateTab)}
                history={props.history}
                location={props.location}
                match={props.match}
                onChangeTab={this.onChangeTab}
                templateTab={templateTab}
            />
        );
    }

    private getBaseUrl(templateTab: ETemplateTab = this.state.templateTab) {
        const {baseUrl} = this.props;

        return `${baseUrl}/${templateTab}`;
    }

    private getTemplateTabState(url: string) {
        return url.includes(ETemplateTab.Sop)
            ? ETemplateTab.Sop
            : ETemplateTab.Analysis;
    }
}

export default injectIntl(Template);
